export default __webpack_public_path__ + "static/media/project3.2cf998de.jpg";